import { motion } from "framer-motion";
import { Spinner } from "reactstrap";

const LoadingScreen = () => {
    return (
        <div className="d-flex align-items-center justify-content-center" style={{ height: "100vh", background: "#f8f9fe" }}>
            <motion.div
                initial={{ opacity: 0, scale: 0.8 }}
                animate={{ opacity: 1, scale: 1 }}
                transition={{
                    duration: 0.5,
                    repeat: Infinity,
                    repeatType: "reverse"
                }}
                className="text-center"
            >
                <img
                    src="/favicon.png"
                    alt="OnEnergy Logo"
                    style={{ height: "80px", marginBottom: "20px" }}
                />
                <div className="mt-3">
                    <Spinner color="primary" style={{ width: '3rem', height: '3rem', color: '#065c53' }} />
                    <h4 className="mt-4 font-weight-bold" style={{ color: '#065c53', letterSpacing: '1px' }}>
                        CONNECTING...
                    </h4>
                </div>
            </motion.div>
        </div>
    );
};

export default LoadingScreen;
